import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import { LogItem } from "../../types/files";
import {
  LogDTO,
  LogList,
  SummaryLogDTO,
  SummaryLogItem,
} from "../../types/log";

const GATEWAY_URL = config.servers.gateway.url;

interface LogApi {
  newLogList(logDTO: LogDTO): Promise<LogList>;
  getSummaryLogList(logDTO: SummaryLogDTO): Promise<SummaryLogItem[]>;
  getLogDetail(req: { logIdList: string[] }): Promise<LogList>;
}

class LogServerApi implements LogApi {
  async newLogList(logDTO: LogDTO): Promise<LogList> {
    const resp = await axios.post<LogList>(
      `${GATEWAY_URL}/wapi/logs/new/paging`,
      logDTO
    );
    return Promise.resolve(resp.data);
  }
  async getSummaryLogList(logDTO: SummaryLogDTO): Promise<SummaryLogItem[]> {
    const resp = await axios.post<SummaryLogItem[]>(
      `${GATEWAY_URL}/wapi/logs/summary`,
      { ...logDTO, timezoneOffset: new Date().getTimezoneOffset() }
    );
    return Promise.resolve(resp.data);
  }
  async getLogDetail(req: { logIdList: string[] }): Promise<LogList> {
    const resp = await axios.post<LogList>(
      `${GATEWAY_URL}/wapi/logs/detail`,
      req
    );
    return Promise.resolve(resp.data);
  }
}
const logApi: LogApi = new LogServerApi();
export default logApi;
